import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupDirective,
} from '@angular/forms';

@Component({
  selector: 'app-other-contacts-subform',
  templateUrl: './other-contacts-subform.component.html',
  styleUrls: ['./other-contacts-subform.component.scss'],
})
export class OtherContactsSubformComponent implements OnInit {
  @Input() title!: string;
  @Input() formGroupName!: string;

  TITLE = 'SHARED.OTHER_CONTACTS.TITLE.';
  PLACEHOLDER = 'SHARED.OTHER_CONTACTS.PLACEHOLDER.';
  HINT = 'SHARED.OTHER_CONTACTS.HINT.';
  REQUIRED = this.HINT + 'REQUIRED';

  form!: UntypedFormGroup;

  constructor(private rootFormGroup: FormGroupDirective) {}

  static buildOtherContactsForm(fb: UntypedFormBuilder): UntypedFormGroup {
    return fb.group({
      facebook: [],
      twitter: [],
      instagram: [],
      linkedIn: [],
      youTube: [],
      whatsApp: [],
      viber: [],
      skype: [],
      web: [],
    });
  }

  ngOnInit(): void {
    if (!this.formGroupName) {
      throw Error('Attribute "formGroupName" is required');
    }
    this.form = this.rootFormGroup.control.get(
      this.formGroupName
    ) as UntypedFormGroup;
  }
}
